<template>
  <b-modal
    hide-footer
    ref="modal"
    modal-class="ga-login-wall-modal"
    body-class="ga-login-wall-modal__body"
    :title="$t('login_wall.title')"
    centered
  >
    <div class="ga-login-wall-modal__content">
      <p v-if="hint" class="ga-login-wall-modal__hint">{{ hint }}</p>
      <p class="ga-login-wall-modal__lead">{{ $t('login_wall.body') }}</p>
      <router-link
        :to="{ name: 'auth.login' }"
        class="ga-login-wall-modal__btn ga-login-wall-modal__btn--primary"
        @click.native="hide"
      >{{ $t('login_wall.login') }}</router-link>
      <router-link
        :to="{ name: 'auth.register' }"
        class="ga-login-wall-modal__btn ga-login-wall-modal__btn--secondary"
        @click.native="hide"
      >{{ $t('login_wall.register') }}</router-link>
      <button
        type="button"
        class="ga-login-wall-modal__btn ga-login-wall-modal__btn--ghost"
        @click="hide"
      >{{ $t('login_wall.cancel') }}</button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'LoginWallModal',
  props: {
    hint: { type: String, default: '' }
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>
